import React from 'react';
import {
  SvgIcon
} from '@mui/material';
import { SvgIconProps } from '@mui/material/SvgIcon';




export default function HomeIconCarre(props: SvgIconProps) {
  return (
    <SvgIcon {...props} className="icon-svg" sx={{ fontSize: '1.25rem', height: 'auto' }}>

        <svg width="22" height="43" viewBox="0 0 22 43" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10.894 0.875C14.5327 0.875 17.4934 3.836 17.4937 7.47461V24.5039L17.7192 24.7246C19.52 26.4863 20.644 28.9197 20.644 31.625C20.644 37.0005 16.2695 41.375 10.894 41.375C5.51856 41.375 1.14404 37.0005 1.14404 31.625L1.15674 31.1436C1.21375 30.0216 1.46659 28.9166 1.90576 27.8799C2.40765 26.6952 3.14231 25.6233 4.06592 24.7275L4.29443 24.5059V7.47461C4.29465 3.836 7.25539 0.875 10.894 0.875Z" fill="#EDF3F3" stroke="#4A598D" stroke-width="1.5"/>
          <path d="M12.2758 5.70072V28.7485C14.6527 29.2437 16.4215 30.9595 16.4215 33.0135C16.4215 35.4522 13.9451 37.4355 10.894 37.4355C7.84278 37.4355 5.36646 35.4522 5.36646 33.0135C5.36646 30.9595 7.13526 29.2437 9.51209 28.7485V5.70072C9.51209 5.09269 10.1339 4.59521 10.894 4.59521C11.654 4.59521 12.2758 5.09269 12.2758 5.70072Z" fill="#4A598D"/>
        </svg>

    </SvgIcon>
  );
}
